/** TRITAL Care de-identified, historical local RN recruiting-demand observations.
 * Counts refer to distinct recently notified job references and do not
 * establish a currently available opening, shift, or candidate compensation.
 * No supplier, facility, rate-card, or source-system details are published.
 */
export const STAFFER_RN_MARKETS = Object.freeze([
  {
    "city": "Bowie",
    "state": "MD",
    "stateName": "Maryland",
    "recentRnOrders": 12,
    "firstSeen": "2026-10-31",
    "lastSeen": "2026-11-03",
    "latestStart": "2026-11-13",
    "setting": "Skilled Nursing / Rehabilitation",
    "role": "Registered Nurse",
    "prn": true,
    "slug": "rn-local-prn-bowie-md",
    "category": "Nursing",
    "arrangement": "PRN / Local",
    "title": "Registered Nurse — PRN & Local Opportunities",
    "isStafferMarket": true,
    "isRecurringPRN": true,
    "verifiedOpen": false,
    "requirements": "Active state or qualifying compact RN license, up-to-date nursing credentials, and client-required skilled nursing or rehabilitation competencies. Experience and availability verified for each individual order. New graduates are not automatically eligible."
  },
  {
    "city": "Wyncote",
    "state": "PA",
    "stateName": "Pennsylvania",
    "recentRnOrders": 2,
    "firstSeen": "2026-11-02",
    "lastSeen": "2026-11-02",
    "latestStart": "2026-11-02",
    "setting": "Skilled Nursing / Rehabilitation",
    "role": "Registered Nurse",
    "prn": true,
    "slug": "rn-local-prn-wyncote-pa",
    "category": "Nursing",
    "arrangement": "PRN / Local",
    "title": "Registered Nurse — PRN & Local Opportunities",
    "isStafferMarket": true,
    "isRecurringPRN": true,
    "verifiedOpen": false,
    "requirements": "Active state or qualifying compact RN license, up-to-date nursing credentials, and client-required skilled nursing or rehabilitation competencies. Experience and availability verified for each individual order. New graduates are not automatically eligible."
  },
  {
    "city": "Wayne",
    "state": "PA",
    "stateName": "Pennsylvania",
    "recentRnOrders": 3,
    "firstSeen": "2026-10-30",
    "lastSeen": "2026-10-31",
    "latestStart": "2026-11-01",
    "setting": "Skilled Nursing / Rehabilitation",
    "role": "Registered Nurse",
    "prn": true,
    "slug": "rn-local-prn-wayne-pa",
    "category": "Nursing",
    "arrangement": "PRN / Local",
    "title": "Registered Nurse — PRN & Local Opportunities",
    "isStafferMarket": true,
    "isRecurringPRN": true,
    "verifiedOpen": false,
    "requirements": "Active state or qualifying compact RN license, up-to-date nursing credentials, and client-required skilled nursing or rehabilitation competencies. Experience and availability verified for each individual order. New graduates are not automatically eligible."
  },
  {
    "city": "Waldorf",
    "state": "MD",
    "stateName": "Maryland",
    "recentRnOrders": 2,
    "firstSeen": "2026-10-30",
    "lastSeen": "2026-10-30",
    "latestStart": "2026-11-01",
    "setting": "Skilled Nursing / Rehabilitation",
    "role": "Registered Nurse",
    "prn": true,
    "slug": "rn-local-prn-waldorf-md",
    "category": "Nursing",
    "arrangement": "PRN / Local",
    "title": "Registered Nurse — PRN & Local Opportunities",
    "isStafferMarket": true,
    "isRecurringPRN": true,
    "verifiedOpen": false,
    "requirements": "Active state or qualifying compact RN license, up-to-date nursing credentials, and client-required skilled nursing or rehabilitation competencies. Experience and availability verified for each individual order. New graduates are not automatically eligible."
  },
  {
    "city": "Gettysburg",
    "state": "PA",
    "stateName": "Pennsylvania",
    "recentRnOrders": 1,
    "firstSeen": "2026-10-30",
    "lastSeen": "2026-10-30",
    "latestStart": "2026-10-29",
    "setting": "Skilled Nursing / Rehabilitation",
    "role": "Registered Nurse",
    "prn": true,
    "slug": "rn-local-prn-gettysburg-pa",
    "category": "Nursing",
    "arrangement": "PRN / Local",
    "title": "Registered Nurse — PRN & Local Opportunities",
    "isStafferMarket": true,
    "isRecurringPRN": true,
    "verifiedOpen": false,
    "requirements": "Active state or qualifying compact RN license, up-to-date nursing credentials, and client-required skilled nursing or rehabilitation competencies. Experience and availability verified for each individual order. New graduates are not automatically eligible."
  }
]);
